import { Errno } from '../../domain/Errno'
import { browserHistory } from '../../libs/historyHelper'
import BottomButtonArea from '../common/BottomButtonArea'
import ErrorScreenTopArea from '../common/ErrorScreenTopArea'
import NavBar from '../common/NavBar'
import useGA4Pageview from '../libs/hooks/useGA4Pageview'

export default function PurchaseFailed({
  errno,
  onDone,
  creamItemId,
}: {
  errno: Errno
  onDone: () => void
  creamItemId: string
}) {
  const isDiscountFailed =
    errno === Errno.ERR_AIFIAN_PAYMENT_SERVICE_CREAM_DISCOUNT_MISMATCH

  useGA4Pageview('slash_error_redeem', isDiscountFailed)
  useGA4Pageview('slash_error_creditcard', !isDiscountFailed)

  return (
    <>
      <NavBar />
      <ErrorScreenTopArea
        title={isDiscountFailed ? '糟糕！折抵沒有成功' : '糟糕！付款沒有成功'}
        content={
          isDiscountFailed ? (
            <p className="babu-text-paragraph mt-xs text-text600">
              折抵金有變動，請再試一次
            </p>
          ) : (
            <>
              <p className="babu-text-paragraph my-xs text-text600">
                可能因為以下原因導致付款不成功，請再試一次，或是聯繫
                <a
                  className="underline"
                  href="https://line.me/R/ti/p/%40mmc8796z"
                  target="_blank"
                  rel="noopener noreferrer">
                  客服人員
                </a>
                為你解決。
              </p>
              <ul className="babu-text-paragraph text-text600">
                <li>1. 信用卡已過期</li>
                <li>2. 銀行系統忙碌中</li>
                <li>3. 輸入卡號不正確</li>
              </ul>
            </>
          )
        }
      />
      <BottomButtonArea
        variant="solid"
        onClick={() => {
          onDone()
          if (creamItemId) {
            browserHistory.push(`buyer/items/${creamItemId}`, {
              isPaymentFailed: true,
            })
            browserHistory.go(0)
          } else {
            browserHistory.push('', {
              isPaymentFailed: true,
            })
          }
        }}>
        再試一次
      </BottomButtonArea>
    </>
  )
}
